import React from 'react';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SyncIcon from '@mui/icons-material/Sync';

import LinkIcon from '@mui/icons-material/Link';
import ErrorIcon from '@mui/icons-material/Error';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { getServiceStatus, syncService } from 'src/services/service.service';

// ----------------------------------------------------------------------

class MiroStatusAndSync extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      connected: false,
      sync_status: null,
      serviceId: props?.serviceId || '',
      loading: false,
      errored: false,
    }

  }

  async componentDidMount() {
    this.getAndUpdateStatus();
  }

  getAndUpdateStatus = async () => {
    this.setState({
      loading: true,
      errored: false,
    });

    let serviceStatusRes = await getServiceStatus(this.state.serviceId);

    if (serviceStatusRes.error) {
      this.setState({
        loading: false,
        errored: true,
      });
      return;
    }

    this.setState({
      connected: serviceStatusRes.connected || false,
      sync_status: serviceStatusRes.sync_status || null,
      loading: false,
      errored: false,
    });
  }

  syncMiro = async () => {
    this.setState({ sync_status: 'syncing' });
    await syncService(this.state.serviceId);
    this.setState({ sync_status: 'synced' });
  }

  render() {

    if (this.state.loading) {
        return (
            <IconButton aria-label="loading" disabled>
                <HourglassEmptyIcon fontSize='small' style={{ color: 'gray' }} />
            </IconButton>
        );
    }

    if (this.state.errored) {
        return (
            <IconButton aria-label="error">
                <ErrorIcon style={{ color: 'red' }} />
            </IconButton>
        );
    }

    return (
      <>
        {(this.state.connected) ? (
          <IconButton aria-label="sync"
            onClick={async () => {
              this.syncMiro();
            }}
            disabled={this.state.sync_status === 'syncing'}
          >
            <SyncIcon fontSize='small' style={this.state.sync_status === 'syncing' ? { animation: 'spin 2s linear infinite reverse' } : {}} />
          </IconButton>
        ) : (
          <IconButton aria-label="connected"
            onClick={() => {
              window.location.href = process.env.REACT_APP_MIRO_INSTALL_URL;
            }}
          >
            <LinkIcon
              fontSize='small'
            />
          </IconButton>
        )}
      </>
    );
  }
}

export default function (props) {
    const navigate = useNavigate();
    return <MiroStatusAndSync {...props} navigate={navigate} />;
}
